import { useGraphql } from 'utils/hooks/useGraphql';

import { FolderId, splitFolderContents } from 'modules/domains/foldering';
import { List, ListSubfolder, ListFoldersGraphQLQueryResponse } from 'modules/domains/list';
import { GRAPHQL_TYPENAMES } from 'modules/graphql/types';

import { TreeViewQueryResponse } from 'ui/indexPages/folders/treeView';
import { fetchListTreeViewQuery } from 'api/queries';
import { useListsContext } from 'modules/listIndex/contexts';

export enum ContentFilter {
  ContentItem = 'ContentItem',
  Subfolder = 'Subfolder',
}

const MAX_TREE_VIEW_FOLDER_COUNT = 1000;

/* Subfolders only: Due to the long-running queries (and timeouts) experienced when querying folders with a large number
 * ContentItems, it has been decided that we will (at least temporarily) only request Subfolders */

export const useListTreeViewQuery = (folderId: FolderId): TreeViewQueryResponse => {
  const { rootFolderId } = useListsContext();
  const { data, isLoading } = useGraphql<ListFoldersGraphQLQueryResponse>(fetchListTreeViewQuery, {
    variables: {
      content: [ContentFilter.Subfolder],
      folderId,
      pagination: {
        limit: MAX_TREE_VIEW_FOLDER_COUNT,
        offset: 0,
      },
    },
    fetchPolicy: 'no-cache',
  });

  const [childFolders = [], childItems = []] = splitFolderContents<ListSubfolder, List>(
    data?.listFolder?.content || [],
    GRAPHQL_TYPENAMES.LIST,
  );

  return {
    childFolders,
    childItems,
    folderData: data?.listFolder || {
      id: rootFolderId,
      name: '',
      ancestors: [],
    },
    isLoading,
  };
};
